import styled from 'styled-components'

type WrapperProps = { topDivider: boolean; inverse: boolean }
export const Wrapper = styled.div<WrapperProps>`
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 118px;
  z-index: 0;

  ${({ topDivider }) =>
    topDivider &&
    `
    bottom: auto;
    top: -1px;
    transform: scaleY(-1);
  `}

  svg {
    width: 100%;
    height: 100%;

    ${({ inverse }) =>
      inverse &&
      `
      transform: scaleX(-1);
      `}
  }

  @media (max-width: 768px) {
    height: 55px;
  }
`
